import { useFormContext } from "react-hook-form";

// Redux

// Services
import { getTranslateByKey } from "@/main/services/utils";

// Types
import { DynamicReportForm } from "../../registerDynamicReport";

// Api

// Components
import KogInputTextControlledNew from "@/main/components/shared/inputText/inputTextControlledNew";
import KOGSection from "@/main/components/shared/kogSection/kogSection";

import * as S from "./styles";
import CopyToClipboardText from "@/main/components/shared/copyToClipboardText/copyToClipboardText";

function QuerySection() {
	const { control, watch } = useFormContext<DynamicReportForm>();

	const queryWatcher = watch("query");

	return (
		<KOGSection
			title={
				<S.TitleContainer>
					{getTranslateByKey("dynamicReport.query")}
					<CopyToClipboardText label={getTranslateByKey("dynamicReport.query")} valueToCopy={queryWatcher || ""}>
						{" "}
					</CopyToClipboardText>
				</S.TitleContainer>
			}
		>
			<S.Container>
				<KogInputTextControlledNew
					label={getTranslateByKey("dynamicReport.query")}
					name="query"
					control={control}
					controllerProps={{ rules: { required: true } }}
					inputProps={{}}
					id="id-dynamicReport-register-query"
					multiline
					minRows={20}
					maxRows={20}
				/>
			</S.Container>
		</KOGSection>
	);
}

export default QuerySection;
